import { useCreateMutation } from '../../../../../../lib/utils/createMutation';
import { UseMutationResult } from '@tanstack/react-query';
import { AccountAdminApiV2 } from '../../../../../../lib/api/account/admin/AccountAdminApiV2';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { AccountAdminCreateResponse, AccountAdminEditPayload } from '../../types/AccountAdminFormType';

import { AccountAdminEditSuccess } from '../../constants';
import { ErrorResponseType, extractErrorMessage } from '../../../../../../lib/utils/checkErrorResponse';
import { HOME_URL_PATH } from '../../../../../../constants/service/common/urlConstants';

const useEditAdminAccount = (): UseMutationResult<
  AccountAdminCreateResponse,
  unknown,
  AccountAdminEditPayload,
  unknown
> => {
  const navigate = useNavigate();

  return useCreateMutation<AccountAdminEditPayload, AccountAdminCreateResponse>({
    queryKey: ['editAccountAdmin'],
    apiFunction: (payload: AccountAdminEditPayload) => AccountAdminApiV2.editAccountAdminDetailInfo(payload),
    onSuccess: () => {
      message.success(AccountAdminEditSuccess);
      navigate(HOME_URL_PATH);
    },
    onError: (error: AxiosError) => {
      const errorMessage = extractErrorMessage(error as ErrorResponseType);
      message.error(errorMessage);
    },
  });
};

export default useEditAdminAccount;
